import { css, Styles, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  list: ({ theme }) => css`
    ${verticalScrollCss(theme)}
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
